export const getUnique = (arr, field) => arr.filter((item, i, arr) => arr.findIndex((el) => el[field] === item[field]) == i);
